export default __webpack_public_path__ + "static/media/fireflink_platform.ecb66757.svg";